import { Link } from 'react-router-dom'
import { pyteen } from '../../../assets'
import '../Project.css'

export default function PyTeen() {

  window.scrollTo(0, 0)
  
  return (
    <>
      <div className='project-wrapper'>
        <div className="project-container">
          <div className='project-image-container'>
            <img src={pyteen} className='project-image'
            alt='PyTeen' />
          </div>
          <div className='project-title'>
            <h1>PyTeen</h1>
          </div>
          <div className='project-description'>
            <p>PyTeen is a convolutional neural network built with PyTorch to conquer the classic MNIST (handwritten digits) dataset. This simple network can be trained and tested from the command line, or within VSCode.</p>
          </div>
          <div className='project-links'>
            <Link to='https://github.com/OwenJRJones/PyTeen'
              target='_blank'
              rel='noreferrer'
            >
              <i className='fab fa-github' >&nbsp;</i>
              GitHub
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
